import React from 'react';
import { useProofOfAddressVerificationContext } from '../../../../../../contexts/proof-of-address-verification/ProofOfAddressVerificationContext';
import { useStore } from '../../../../../../hooks/useStore';
import { translate } from '../../../../../../services/translate';
import { stores } from '../../../../../../stores';
import UiButton from '../../../../../ui/button/UiButton';
import AccountVerificationProofOfAddressHeader from '../../header/AccountVerificationProofOfAddressHeader';

export default function AccountVerificationProofOfAddressSteps0() {
    const [kycSettings] = useStore(stores.kyc.settings);
    const { setActiveStep, documentUpload } = useProofOfAddressVerificationContext();

    return (
        <>
            <AccountVerificationProofOfAddressHeader>
                {documentUpload.statusAlert}
            </AccountVerificationProofOfAddressHeader>
            {documentUpload.isEnabled && !kycSettings.isIdenfyEnabled && (
                <UiButton onClick={() => setActiveStep(1)} block>
                    {translate('Upload documents', 'ui.account.kyc')}
                </UiButton>
            )}
        </>
    );
}
